module.exports = __webpack_public_path__ + "static/media/Taru.8689be25.jpg";